/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { PageTitle } from "../../../_metronic/layout/core";
import { BASE_URL } from "../../modules/profile/components/constants";
import { MONEY } from "../../modules/profile/components/util";
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  CardsWidget21,
  ChartsWidget1,
  ListsWidget26,
  EngageWidget10,
} from "../../../_metronic/partials/widgets";
import axios from "axios";
import { CardsWidgetExtra } from "../../../_metronic/partials/widgets/_new/cards/CardsWidgetExtra";
import { NavLink } from "react-router-dom";

type RequestItem = {
  wft_id: number;
  wft_name: string;
  wft_visible_to_client: string;
  count_open: string | number;
  count_hold: string | number;
};
type requestsType = RequestItem[];
const DashboardPage: FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<{
    requests: requestsType;
    pending_orders_count: number | string;
    active_subscriptions_count: number | string;
    overdue_invoices_count: number | string;
    total_outstanding: number | string;
    currency_name: number | string;
    trouble_tickets: number | string;
    training_tickets: number | string;
    service_tickets: number | string;
  }>({
    pending_orders_count: 0,
    active_subscriptions_count: 0,
    overdue_invoices_count: 0,
    total_outstanding: 0,
    currency_name: "",
    trouble_tickets: 0,
    training_tickets: 0,
    service_tickets: 0,
    requests: [],
  });

  const loadStats = async () => {
    try {
      setIsLoading(true);
      let results = await axios.get(
        `${BASE_URL}reports/client/dashboard-stats`
      );
      if (results.data.status) {
        setData(results.data.data);
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  console.log(data);
  return (
    <>
      <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
        {/* begin::Col */}

        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-md-5 mb-xl-10 ">
          <NavLink to={"/subscriptions/list?page=1&subscription_status=Active"}>
            <CardsWidget21
              className="h-md-100 mb-5 mb-xl-10"
              description="Units Online"
              color="#44A3C2"
              total={data.active_subscriptions_count}
              img={toAbsoluteUrl("")}
            />
          </NavLink>
        </div>
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-md-5 mb-xl-10 ">
          <NavLink to={"/statements/outstanding"}>
            <CardsWidget21
              className="h-md-100 mb-5 mb-xl-10"
              description="Overdue Invoices"
              color="#e3d346"
              total={data.overdue_invoices_count}
              img={toAbsoluteUrl("")}
            />
          </NavLink>
        </div>
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-md-5 mb-xl-10 ">
          <NavLink to={"/statements/outstanding"}>
            <CardsWidget21
              className="h-md-100 mb-5 mb-xl-10"
              description="Total Outstanding"
              color="#2ea64e"
              total={`${data.currency_name} ${MONEY(
                data.total_outstanding
              ).format()}`}
              img={toAbsoluteUrl("")}
            />
          </NavLink>
        </div>
        {/* end::Col */}
      </div>
      <div className="row">
        {data.requests.map((II) => (
          <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10 ">
            <CardsWidgetExtra
              className="h-md-100 mb-5 mb-xl-10 "
              title={II.wft_name}
              open={II.count_open}
              hold={II.count_hold}
              // visible_to_client={II.wft_visible_to_client}
              // description="Total Outstanding XXX"
              // color="#2ea64e"
              // total={`${data.currency_name} ${MONEY(
              //   data.total_outstanding
              // ).format()}`}
              // img={toAbsoluteUrl("")}
            />
          </div>
        ))}
      </div>
      {false ? (
        <>
          <div
            className="row g-5 g-xl-10 mb-5 mb-xl-10"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {/* begin::Col */}
            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">
              <CardsWidget21
                className="h-md-100 mb-5 mb-xl-10"
                description="Trouble Ticket"
                color="#338B86"
                total={data.trouble_tickets}
                img={toAbsoluteUrl("")}
              />
            </div>
            {/* end::Col */}
            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">
              <CardsWidget21
                className="h-md-100 mb-5 mb-xl-10"
                description="Service Ticket"
                color="#C25D44"
                total={data.service_tickets}
                img={toAbsoluteUrl("")}
              />
            </div>
            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">
              <CardsWidget21
                className="h-md-100 mb-5 mb-xl-10"
                description="Training Ticket"
                color="#447EC2"
                total={data.training_tickets}
                img={toAbsoluteUrl("")}
              />
            </div>
          </div>
          {/* begin::Row */}
          <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
            {/* begin::Col */}
            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-5 mb-md-5 mb-xl-10">
              <ChartsWidget1 className="text-danger" />
            </div>
            {/* end::Col */}

            <div className="col-xxl-7">
              <EngageWidget10 className="h-md-100" />
            </div>
          </div>
          {/* end::Row */}
        </>
      ) : null}
    </>
  );
};

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: "MENU.DASHBOARD" })}
      </PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };
